import { NpmRegistryAuthType, NpmRegistryType, nullishToOptional } from "@supernova-studio/model";
import { z } from "zod";

//
// Read
//

export const DTONpmRegistryConfigConstants = {
  passwordPlaceholder: "redacted",
};

export const DTONpmRegistryConfig = z.object({
  // Registry basic configuration
  registryType: NpmRegistryType,
  registryUrl: z.string(),
  customRegistryUrl: z.string().optional(),

  // URL of Supernova NPM packages proxy
  proxyUrl: z.string(),

  // Auth configuration
  authType: NpmRegistryAuthType,
  accessToken: z.literal(DTONpmRegistryConfigConstants.passwordPlaceholder).optional(),
  username: z.string().optional(),
  password: z.literal(DTONpmRegistryConfigConstants.passwordPlaceholder).optional(),

  // NPM package scopes for whih the proxy should be enabled
  enabledScopes: z.array(z.string()),

  // True if client should bypass Supernova proxy and connect directly to the registry
  // (e.g. when the NPM registry is behind a VPN or firewall which prevents Supernova from accessing it)
  bypassProxy: z.boolean(),
});

export const DTONpmRegistryAccessTokenResponse = z.object({
  version: z.number(),
  accessToken: z.string().optional(),
  registryUrl: z.string(),
});

export const DTOUpdateRegistryInput = z.object({
  registryType: nullishToOptional(NpmRegistryType),
  authType: nullishToOptional(NpmRegistryAuthType),
  enabledScopes: nullishToOptional(z.array(z.string())),
  customRegistryUrl: nullishToOptional(z.string()),
  bypassProxy: nullishToOptional(z.boolean()),
  npmProxyVersion: nullishToOptional(z.number()),
  authHeaderName: nullishToOptional(z.string()),
  authHeaderValue: nullishToOptional(z.string()),
  accessToken: nullishToOptional(z.string()),
  username: nullishToOptional(z.string()),
  password: nullishToOptional(z.string()),
});

export const DTOUpdateRegistryOutput = z.object({
  npmRegistrySettings: DTONpmRegistryConfig,
});

export type DTONpmRegistryConfig = z.infer<typeof DTONpmRegistryConfig>;
export type DTONpmRegistryAccessTokenResponse = z.infer<typeof DTONpmRegistryAccessTokenResponse>;
export type DTOUpdateRegistryInput = z.infer<typeof DTOUpdateRegistryInput>;
export type DTOUpdateRegistryOutput = z.infer<typeof DTOUpdateRegistryOutput>;
